import Caracterisation from "@/pages/administrer/configuration/caracterisation/Caracterisation.vue";
import CreateCaracterisation from "@/pages/administrer/configuration/caracterisation/CreateCaracterisation.vue";
import ShowCaracterisation from "@/pages/administrer/configuration/caracterisation/ShowCaracterisation.vue";

export default [{
    path: 'caracterisations',
    name: "AdminConfigCaracterisation",
    component: Caracterisation
},
{
    path: 'caracterisations/create',
    name: "AdminConfigCreateCaracterisation",
    component: CreateCaracterisation
},
{
    path: 'caracterisations/:id/show',
    name: "AdminConfigShowCaracterisation",
    component: ShowCaracterisation
}]